import * as z from 'zod';

const dateRange = z.object({
  from: z.date().optional(),
  to: z.date().optional(),
});

export const formSchema = z.object({
  plant: z.string().optional(),
  material: z.string().optional(),
  materialDescription: z.string().optional(),
  batch: z.string().optional(),
  action: z.string().optional(),
  createdAt: dateRange.optional(),
  justificationStatus: z.string().optional(),
  sortingBias: z.string().optional(),
});

export type FormSchema = z.infer<typeof formSchema>;
